import { render } from "./Restorants.vue?vue&type=template&id=6f4851bb&scoped=true&ts=true"
import script from "./Restorants.vue?vue&type=script&lang=ts"
export * from "./Restorants.vue?vue&type=script&lang=ts"

import "./Restorants.vue?vue&type=style&index=0&id=6f4851bb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4851bb"]])

export default __exports__